import { DATE_ACTIONS } from 'constants/common';
import { isEmpty } from 'lodash';
import moment from 'moment-timezone';
import caLocale from 'moment/locale/fr-ca';
import esLocale from 'moment/locale/es';
import ptLocale from 'moment/locale/pt-br';

const APP_TIMEZONE = 'America/New_York';

const LOCALE = {
  fr: caLocale,
  sp: esLocale,
  br: ptLocale
};

export const DATE_TIME_FORMAT = 'MMM DD, YYYY - HH:mm:ss';
export const DATE_TIME_FORMAT_NO_SECOND = 'MMM DD, YYYY - HH:mm:00';
export const DATE_TIME_FORMAT_NO_SECOND_12H = 'MMM DD, YYYY - h:mm:00 A';
export const DATE_FORMAT = 'MMM DD, YYYY';
export const TIME_FORMAT_NO_SECOND_12H = 'hh:mm A';
export const DATE_FORMAT_WITH_SLASH = 'MM/DD/YY';
export const DATE_FORMAT_ISO = 'YYYY-MM-DD';

export const setMomentLocale = (language = 'en') => {
  if (language === 'en') {
    moment.locale(language);
    return;
  }
  moment.updateLocale(language, LOCALE[language]);
};

setMomentLocale(localStorage.getItem('language') || 'en');

export const getTimeLocal = (time = new Date()) => {
  return moment.tz(time, APP_TIMEZONE);
};

export const getTimeFormat = (
  time,
  format = 'DD MMM YYYY - hh:mm:ss',
) => {
  return time ? moment.tz(time, APP_TIMEZONE).format(format) : '';
};

export const parseTimezone = (date) => {
  if (isEmpty(date)) return undefined;
  return moment.tz(date, APP_TIMEZONE);
};

export const parseUTC = (
  date,
  action = '',
  segment = 'days',
) => {
  if (isEmpty(date)) return undefined;
  let parsedDate = moment.tz(date, APP_TIMEZONE);
  if (action === DATE_ACTIONS.START) {
    parsedDate.startOf(segment);
  }
  if (action === DATE_ACTIONS.END) {
    parsedDate.endOf(segment);
  }
  return parsedDate.toISOString();
};

export const getDateOnly = (date) => {
  if (isEmpty(date)) return undefined;
  return moment(date).format(DATE_FORMAT_ISO);
} 

export const range = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};

export const getDisabledTime = (form, date, isStart = true) => {
  if (date) {
    const currentDate = moment();
    if (date.isSame(currentDate, 'day')) {
      return {
        disabledHours: isStart
          ? () => range(0, currentDate.hour())
          : () => range(currentDate.hour() + 1, 24),
        disabledMinutes: isStart
          ? () =>
              date.hour() > currentDate.hour()
                ? []
                : range(0, currentDate.minute())
          : () =>
              date.hour() < currentDate.hour()
                ? []
                : range(currentDate.minute() + 1, 60),
      };
    } else {
      if (isStart) {
        const endDate = form.getFieldValue('endDate');
        if (endDate && date.isSame(endDate, 'day')) {
          return {
            disabledHours: () => range(endDate.hour() + 1, 24),
            disabledMinutes: () =>
              date.hour() < endDate.hour()
                ? []
                : range(endDate.minute() + 1, 60),
          };
        }
      }
    }
  }
  return {};
};
